import { render, staticRenderFns } from "./templateTodoListModal.vue?vue&type=template&id=c23d837e&"
import script from "./templateTodoListModal.vue?vue&type=script&lang=ts&"
export * from "./templateTodoListModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports